import { DatePipe, Location } from '@angular/common';
import { Component,ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as FileSaver from 'file-saver';
import { Subject,forkJoin } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { RadiologyEhr, RadiologyEhrData } from '../../../../@core/interfaces/ehr/radiology-ehr';
import { Physician, PhysicianData } from '../../../../@core/interfaces/masters/physician-mst';
import { NbDateService, NbDialogRef, NbDialogService, NbTabsetComponent } from '@nebular/theme';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { PatientRegistrationData } from '../../../../@core/interfaces/patient-services/patient-registration';
import { DateService } from '../service/date.service';
import * as period from '../../../../data/period.json';
import * as category from '../../../../data/attachment-category.json';
import * as subCategory from '../../../../data/attachment-sub-category.json';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { UserData } from '../../../../@core/interfaces/common/users';

import { DICOMViewerComponent } from '../../../../pages/dicom-viewer/dicom-viewer.component';
import { DicomUploadService } from '../../../../dicom-upload.service';
import * as cornerstone from 'cornerstone-core';
import * as cornerstoneTools from 'cornerstone-tools';
import * as cornerstoneWebImageLoader from 'cornerstone-web-image-loader';
import * as dicomParser from 'dicom-parser';
import { ToastrAppSrvcService } from '../../../../_services/toastr-app-srvc.service';
import { PrinterSettings } from '../../../../@core/interfaces/masters/printersettings';
import { imageatch_detData } from '../../../../@core/interfaces/masters/imageatch_det';


@Component({
  selector: 'ngx-new-attachment',
  templateUrl: './new-attachment.component.html',
  styleUrls: ['./new-attachment.component.scss']
})

export class NewAttachmentComponent implements OnInit {
  protected readonly unsubscribe$ = new Subject<void>();
  allowClear: boolean = true;
  multiple: boolean = false;
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  objectKeys = Object.keys;
  @Input() regId: string="";
  filesDet: RadiologyEhr[];
  dateFilter: RadiologyEhr[];
  phyList: Physician[];
  atchForm: FormGroup;
  term: string;
  p: number = 1;
  isBtnSubmitted = false;
  isSubmitted = false;
  editDet: RadiologyEhr;
  fileToUpload: File = null;
  isImgView: boolean = false;
  srcname: string="";
  rangeDate: Date[];
  max: Date;
  userAccessData: any;
  isView: Boolean = false;
  isEdit: Boolean = false;
  isCreate: Boolean = false;
  isPrint: Boolean = false;
  isShare: Boolean = false;
  isDelete: Boolean = false;
  @Input() fromPatReg;
  @Input() isCategoryFieldReadOnly: boolean = true;
  @Input() patientRegAttach;
  @Input() ehrAttach;
  //should be shared to this component for functionality
  @Input() email: string = "";
  @Input() mobileNumber: string = "";
  @Input() name: string = "";
  @Input() category: string = "";
  @Input() subCategory: string = "";
  @Input() referenceNo: string = "";
  @Input() patient;
  @Input() ehrFlag;
  isconfirmation: boolean = false;
  deleteflag: boolean = false
  @ViewChild("nestedTabRef") tabsetE2: NbTabsetComponent;
  filesizeflag: boolean = false;
  filesize: string;
  smsdto = { "variables": [], "template_id": "", "to": "", "service": "" };
  ApiModel = { "content": "", "toname": "", "toemailid": "", "pagename": "", "subject": "", "branchname": "", "branchcontactnumber": "" };
  categoryOptions = (category as any).default;
  subCategoryOptions = (subCategory as any).default;
  periodList: string[] = (period as any).default;
  storageExceeds: boolean = false;
  storageExceedsErrMsg: boolean = false;
  betweenFlag: boolean;
  period: string;
  attachmentList: Array<any> = [];
  attachmentListGrid: Array<any> = [];
  fromDate: string | Date;
  toDate: string | Date;
  searchType : any;
  iconView: boolean;
  addAttachment: boolean;
  uploadProgress: number;
  doneBy: number = parseInt(localStorage.getItem("userId"));
  subCategorySelected: { categorys: string; subCategory: string; }[];
  userdata: Array<any> = [];
  totalAttachment: Array<any> = [];
  towhatsappnumber: string;
  whatsappcontent: string;
  dialogRef: any;
  resultContent: any;
  @ViewChild('whatsappDialog') whatsappDialog: TemplateRef<any>;
  docType: string;
  vopdFlag: boolean;
  selectDate:boolean=false;
  imagesToDisplay:Array<any>=[];
  @Input() visitId:number;
  @Input() showBackIcon:boolean = false;
  @Input() fromMaster:boolean = false;
  @Output() valueUpdateEvent = new EventEmitter<string>();
  @Output() attachmentSaved = new EventEmitter<void>();
  @Input() woundCare;
  
  styleUrl="/assets/css/print.css,/assets/css/a4landscape.css";
  Printsrcname="../.././../../assets/images/white.png";
  psDetails:PrinterSettings;
  @ViewChild('printButton', { static: false }) printButton: ElementRef;   
  @ViewChild('printSection', { static: false }) printSection!: ElementRef;

  sourceData:Array<any>=[{id: 1, value: 'Hospital'}, {id: 2, value: 'Patient'}];
  addedBy:string;
  lastAttachmentIcon:string;
  groupedAttachments:Array<any>=[];
  imagelistload:boolean=false;
  currentView:any={}
  keyValue:string;
  folderView:boolean=false;
  groupByType = 'detail';
  valuePair:Array<any>=[];
  toolView:boolean=false;
  searchBtn:boolean=false;
  updatePair:any={};
  updateFlag:boolean=false;
  sourceDisable:boolean=false;
  searchlist :Array<any>=[{id: 1, value: 'All'}];
  isRmsTenant : boolean = false; 

    
  @ViewChild(DICOMViewerComponent, { static: false }) viewPort: DICOMViewerComponent;
    responses: any[] = [];
  uploadedImages: any[] = [];
  uploadError: string | null = null;
  thumbnailImages: any[] = [];
  @Input() crosshairModeEnabled: boolean = false;
  showImageViewer = false;
  selectedImage: any = null;
  deletedImageFilenames: string[] = [];
  errorMessage: string = '';
  selectedImages: any[] = [];
  selectionMode: boolean = false;
 intialFlag:boolean=false;


  imageUrl: any = null;
  metadata: any = null;
  isLoadingApiImage: boolean = false;
  apiImage: any = null;
  sortOrder: 'Asc' | 'Dsc' = 'Asc';
  
  
  constructor(protected userService: UserData, private dialogService: NbDialogService, private dateServices: DateService, protected patRegSrvc: PatientRegistrationData, private radiologySrvc: RadiologyEhrData, protected dateService: NbDateService<Date>, protected phySrvc: PhysicianData,
    private dicomUploadService: DicomUploadService,private toaster: ToastrAppSrvcService,
    private iatchSrvc: imageatch_detData,
    private fb: FormBuilder, private route: ActivatedRoute, private datePipe: DatePipe, protected rolesService: RolesData,public location: Location) {
    this.route.params.subscribe(params => {
      this.regId = params['regId'];
    });
    this.atchForm = this.fb.group({
      file: this.fb.control(null, [Validators.required]),
      notes: this.fb.control(null),
      tagName:this.fb.control(null)
      // doneby: this.fb.control(null,[Validators.required , Validators.maxLength(25)]),      
      // category: this.fb.control(null, [Validators.required]),     
    });

  }




  ngOnInit(): void {
    this.period = "Today";
    this.searchDet();
    this.fetchUsertype();
    this.userAccessData
    this.fetchPageAccess();
    this.referenceNo  = 
    this.referenceNo == "" || this.referenceNo == null || this.referenceNo == undefined || this.referenceNo == "null" || this.referenceNo == "undefined" ?
    null : this.referenceNo;
     this.initializeCornerstone();
    // this.fetchImageFromApi();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && (changes['name'] || changes['mobileNumber'])) {
      const change = changes['category'];
      this.isRmsTenant = this.tenantId == "6bced242-032d-47d6-e7cb-08d8f2bf3f35" ? true : false;
      if(this.isRmsTenant){
         this.searchType = "All";
      }
      this.searchDet();
    }
  }
  
  startPatientData() {
    this.loadPhy();
    this.searchDet();
    this.fetchPageAccess();
    this.max = this.dateService.addDay(new Date(Date.now()), 0);
    this.getStorageDet();
  }

  vopd(regId){
    this.regId =regId ;
    this.vopdFlag=true;
  }
  
  cancelAddAttachment() {
    this.addAttachment = false;
    this.atchForm.reset();
    this.fileToUpload = null;
    this.uploadProgress = 0;
    //this.sourceDisable=false;
    if(this.ehrFlag)
        this.isCategoryFieldReadOnly=false;
  }

  send_Email(x: RadiologyEhr) {
    const contentDataURL = "image";
    this.ApiModel.content = contentDataURL;
    this.ApiModel.toname = this.name;
    this.ApiModel.toemailid = this.email;
    this.ApiModel.pagename = "Attachment";
    this.ApiModel.subject = "Attachment";
    this.ApiModel.branchname = x.tenantId;
    this.ApiModel.branchcontactnumber = "9876543210";

    this.patRegSrvc.send_email('patientregistrationmst/' + this.tenantId + '/' + this.branchId + '/' + 'SendNotification', this.ApiModel).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    }, (error) => {
      // console.error(error);
    });
  }
  
  send_SMS(x: RadiologyEhr) {
    this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/sendsms`, x).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    }, (error) => {
    }, () => {
    });
  }



  send_WTSP(x: RadiologyEhr) {
    this.towhatsappnumber = this.mobileNumber;
    x.isCreate = this.isCreate;
    x.isEdit = this.isEdit;
    x.isView = this.isView;
    this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/uri`, x).pipe(takeUntil(this.unsubscribe$)).subscribe((datam: any) => {
      var data = datam;
      this.whatsappcontent = data;
      this.resultContent = `Dear ${this.name}, Please click on the link to view your medical record.` + ' ' + this.whatsappcontent;
      this.dialogRef = this.dialogService.open(
        this.whatsappDialog,
        {
          closeOnBackdropClick: false,
          closeOnEsc: false
        });
    }, (error) => {

    }, () => {

    });

  }

  onCategoryChange() {
    this.subCategorySelected = this.subCategoryOptions.filter(e => e.categorys == this.category);
  }


  goToLink(ref) {
    let encodedContent = encodeURIComponent(this.resultContent);
    window.open('https://web.whatsapp.com/send?phone=91' + this.towhatsappnumber + '&text=' + encodedContent, "_blank");
    this.cancelNotification(ref);
  }
  cancelNotification(ref: NbDialogRef<any>) {
    ref.close();
  }

  TabClick(event) {
    if (event.tabTitle == "Attachments") {
      this.searchDet();
      this.onReset();
    }
  }
  // user role attachment start RAJA 22-11-21
  fetchPageAccess() {
    this.isCreate=true;
    this.isDelete=true;
    this.isEdit=true;
    this.isView=true;
    this.isPrint=true;
    this.isShare=true;
    // if (this.fromPatReg && this.fromPatReg != undefined && this.fromPatReg != null) {
    //   this.userAccessData = this.patientRegAttach;
    //   let View = this.userAccessData.filter(element => access.task.REGATTACH == element.taskID && element.actionID == access.action.VIEW && element.permission == "true");
    //   if (View.length > 0) this.isView = true;
    //   let Create = this.userAccessData.filter(element => access.task.REGATTACH == element.taskID && element.actionID == access.action.CREATE && element.permission == "true");
    //   if (Create.length > 0) this.isCreate = true;
    //   let Edit = this.userAccessData.filter(element => access.task.REGATTACH == element.taskID && element.actionID == access.action.EDIT && element.permission == "true");
    //   if (Edit.length > 0) this.isEdit = true;

    //   let share = this.userAccessData.filter(element => access.task.REGATTACH == element.taskID && element.actionID == access.action.SHARE && element.permission == "true");
    //   if (share.length > 0) this.isShare = true;
    //   let print = this.userAccessData.filter(element => access.task.REGATTACH == element.taskID && element.actionID == access.action.PRINT && element.permission == "true");
    //   if (print.length > 0) this.isPrint = true;

    //   var del = this.userAccessData.filter(element => access.task.REGATTACH == element.taskID && element.actionID == access.action.DELETE && element.permission == "true");
    //   if (del.length > 0) this.isDelete = true;

    // }
    // else {

    //   this.userAccessData = this.ehrAttach;
    //   let View = this.userAccessData.filter(element => access.task.EHROPADVCASESHEET == element.taskID && element.actionID == access.action.VIEW && element.permission == "true");
    //   if (View.length > 0) this.isView = true;
    //   let Create = this.userAccessData.filter(element => access.task.EHROPADVCASESHEET == element.taskID && element.actionID == access.action.CREATE && element.permission == "true");
    //   if (Create.length > 0) this.isCreate = true;
    //   let Edit = this.userAccessData.filter(element => access.task.EHROPADVCASESHEET == element.taskID && element.actionID == access.action.EDIT && element.permission == "true");
    //   if (Edit.length > 0) this.isEdit = true;
    //   let share = this.userAccessData.filter(element => access.task.EHROPADVCASESHEET == element.taskID && element.actionID == access.action.SHARE && element.permission == "true");
    //   if (share.length > 0) this.isShare = true;
    //   let print = this.userAccessData.filter(element => access.task.EHROPADVCASESHEET == element.taskID && element.actionID == access.action.PRINT && element.permission == "true");
    //   if (print.length > 0) this.isPrint = true;
    //   var del = this.userAccessData.filter(element => access.task.EHROPADVCASESHEET == element.taskID && element.actionID == access.action.DELETE && element.permission == "true");
    //   if (del.length > 0) this.isDelete = true;
    // }
  }


  onSearchChange(args: any): void {
      this.attachmentList = this.totalAttachment.filter(x => (x.fileName as string).toLocaleLowerCase().indexOf(this.term.toLocaleLowerCase()) > -1 || x.category.toLocaleLowerCase().indexOf(this.term.toLocaleLowerCase()) > -1 || x.doneBy.toLocaleLowerCase().indexOf(this.term.toLocaleLowerCase()) > -1 || x.category.toLocaleLowerCase().indexOf(this.term.toLocaleLowerCase()) > -1 || x.notes.toLocaleLowerCase().indexOf(this.term.toLocaleLowerCase()) > -1);
      this.filterGrid(this.attachmentList);
      this.groupBy(this.attachmentList,this.groupByType);
  }

  changeDocType(docType:string){
    this.backToMain();
    if(this.docType==undefined || this.docType==""){
      const button = document.getElementById("all");
      button.setAttribute("data-selected", "false");
    }
    if(this.docType!=null && this.docType!="" && this.docType!=undefined){
      const button = document.getElementById(this.docType);
      button.setAttribute("data-selected", "false");
    }
    this.docType=docType;
    const button = document.getElementById(docType);
    button.setAttribute("data-selected", "true");
    if(docType=='all'){
      this.attachmentList = this.totalAttachment;
       this.filterGrid(this.attachmentList);
     this.groupBy(this.attachmentList,this.groupByType);
      return;
    }
    if(docType=='img'){
      this.attachmentList = this.totalAttachment.filter(x => (x.fileName as string).toLocaleLowerCase().indexOf("png") > -1 || (x.fileName as string).toLocaleLowerCase().indexOf("jpeg") > -1 || (x.fileName as string).toLocaleLowerCase().indexOf("jpg") > -1);
       this.filterGrid(this.attachmentList);
     this.groupBy(this.attachmentList,this.groupByType);
      return;
    }
    if(docType=='audio'){
      this.attachmentList = this.totalAttachment.filter(x => (x.fileName as string).toLocaleLowerCase().indexOf("mp3") > -1);
       this.filterGrid(this.attachmentList);
     this.groupBy(this.attachmentList,this.groupByType);
      return;
    }
    if(docType=='document'){
      this.attachmentList = this.totalAttachment.filter(x => (x.fileName as string).toLocaleLowerCase().indexOf("docx") > -1);
       this.filterGrid(this.attachmentList);
     this.groupBy(this.attachmentList,this.groupByType);
      return;
    }
    if(docType=='excel'){
      this.attachmentList = this.totalAttachment.filter(x => ((x.fileName as string).toLocaleLowerCase().indexOf("xlsx") > -1) || ((x.fileName as string).toLocaleLowerCase().indexOf("csv") > -1));
       this.filterGrid(this.attachmentList);
     this.groupBy(this.attachmentList,this.groupByType);
      return;
    }
    if(docType=='powerPoint'){
      this.attachmentList = this.totalAttachment.filter(x => (x.fileName as string).toLocaleLowerCase().indexOf("pptx") > -1);
       this.filterGrid(this.attachmentList);
     this.groupBy(this.attachmentList,this.groupByType);
      return;
    }
    this.attachmentList = this.totalAttachment.filter(x => (x.fileName as string).toLocaleLowerCase().indexOf(docType.toLocaleLowerCase()) > -1);

     this.filterGrid(this.attachmentList);
     this.groupBy(this.attachmentList,this.groupByType);
  }

  searchDet() {
    this.searchBtn=true;
    if(this.tenantId!=null && this.branchId!=null){
    var method;
    if(this.regId == '00000000-0000-0000-0000-000000000000'){
      method = 'GetUploadedListForMaster';
    }
    else{
      if(this.woundCare || this.ehrFlag){
        method = 'WoundCareAttachmentList'
      }else{
      method = 'GetUploadedList';}
    }
    this.getDateObj();
    let searchData = {
      from: this.fromDate,
      to: this.toDate,
      tenantId: this.tenantId,
      branchId: this.branchId,
      category: this.category,
      subcategory: this.subCategory,
      referenceNo: this.referenceNo,
      searchType : this.searchType,
      searchText: this.term
    }
    const payload = {
    "fromDate": this.fromDate,
    "toDate": this.toDate,
    "tenantId": this.tenantId,
    "category": this.category,
    "firstName": this.name,
    "mobile": this.patient?.patientNumber || this.mobileNumber,
    "searchType": this.searchType
    }
    let url = (this.woundCare || this.ehrFlag)?`${this.getApiUrl}/WoundCare/WoundCareAttachmentList`:`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/${method}`
    this.radiologySrvc.create(url, ((this.woundCare || this.ehrFlag)?payload:searchData)).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      data.details = data.details?.map(x => {return{...x, compareCheck : false}});
      if(this.woundCare || this.ehrFlag){
        data = data?.details;
       // if(this.woundCare)data = data?.filter(x => x?.referenceNo  == this.referenceNo);
      }
      if (data == null || data?.length == 0) {
        this.attachmentList = [];
      }
      this.attachmentList = data;
      this.totalAttachment = data;
      this.valuePair=[];
      this.folderView=false;
      this.filterGrid(this.attachmentList);
      this.groupBy(data,this.groupByType);
       const allowedExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg",
      ".dcm",".ima"];
      var exattachmentListGrid = data.filter(x =>
          allowedExtensions.some(ext => (x.fileName as string).toLowerCase().includes(ext))
        );
      this.sendStaticPayload(exattachmentListGrid);
      this.toggleSort();

      

    }, (error) => {
      this.attachmentList = [];
      this.searchBtn=false;
    },()=>{ this.searchBtn=false;});
    }

  }

  getDateObj() {
    var date = this.dateServices.currentDate();
    if (this.period != "" && this.period != "Between") {
      switch (this.period) {
        case 'Today':
          this.rangeDate = null;
          this.fromDate = date;
          this.toDate = date;
          break;
        case 'Yesterday':
          date.setDate(date.getDate() - 1);
          this.fromDate = date;
          this.toDate = date;
          break;
        case 'This Week':
          var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
          this.fromDate = new Date(today.setDate(today.getDate() - today.getDay()));
          this.toDate = date;
          break;
        case 'This Month':
          this.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
          this.toDate = date;
          break;
        case 'This Year':
          this.fromDate = new Date(date.getFullYear(), 0, 1);
          this.toDate = date;
          break;
      }
      this.fromDate = this.dateServices.utcFromDate(this.fromDate);
      this.toDate = this.dateServices.utcToDate(this.toDate);
    } else {
      this.fromDate = this.dateServices.utcFromDate(this.rangeDate[0]);
      this.toDate = this.dateServices.utcToDate(this.rangeDate[1]);
    }
  }

  onReset() {
    this.currentView={};
    this.term = "";
    this.rangeDate = null;
    this.period = "Today";
    this.category = this.ehrFlag?'EHR':this.category;
    this.searchDet();
    this.filesDet = this.filesDet = this.dateFilter?.filter(x => {
      let tempregDate: Date = new Date(x.doneDate);
      return this.dateService.compareDates(new Date(tempregDate.setHours(0, 0, 0, 0)), new Date(this.dateService.today().setHours(0, 0, 0, 0))) == 0;
    });
  }

  loadPhy(): void {
    this.phySrvc.list(`physicians/${this.tenantId}/${this.branchId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.phyList = data.value;
    }, (error) => {
    }, () => {
    });
  }

  calculateDiff(dateSent){
    let currentDate = new Date();
    dateSent = new Date(dateSent);
    return Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate()) ) /(1000 * 60 * 60 * 24));
}

  onPeriodChange(event) {
    if (event.length > 0 && event != undefined) {
      this.betweenFlag = false;
      if (event[0]?.value == "Between") {
        this.betweenFlag = true;
      }
    }
  }

  isDateDisable : boolean = false;
  onDateChange(event){
    var search = event[0]?.value;
     this.isDateDisable = false;
    if(search == "All"){
      this.isDateDisable = true;
      this.period = null;
      this.fromDate = null;
      this.toDate = null;
    }
    if(this.isDateDisable == false && this.period == null){
     this.period = "Today";
    }
  }

  callEdit(x: RadiologyEhr): void {
    this.editDet = x;
  }

  getUserNameById(id:string){
    let userDet = this.userdata.filter(e=>e.id?.toString()==id);
    return userDet[0]?.firstName;
  }

  download(x: RadiologyEhr): void {
    x.isCreate = this.isCreate;
    x.isEdit = this.isEdit;
    x.isView = this.isView;

    if(!x.visitId){
      x.visitId = null;
    }
    if(!x.regId){
      x.regId = "00000000-0000-0000-0000-000000000000";
    }
    if(!x.regMst){
      x.regMst = null
    }

    this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/download`, x).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {


      this.downloadFileRes(data, x.fileName);


    }, (error) => {

    }, () => {

    });



  }
  Delete(x: RadiologyEhr) {
    this.radiologySrvc.delete(`${environment.apiUrl}/AtchDet/${this.tenantId}/${this.branchId}/${x.id}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

    }, (error) => {
    }, () => {
      this.attachmentList = this.attachmentList.filter(data => data.id != x.id);
      this.totalAttachment = this.totalAttachment.filter(data => data.id != x.id)
      this.deleteflag = true
      setTimeout(() => {
        this.deleteflag = false;
      }, 4000);

    });
    this.filterGrid(this.attachmentList);
    this.groupBy(this.attachmentList,this.groupByType);
  }

  view(x: RadiologyEhr): void {
    this.fetchPageAccess();
    x.isCreate = this.isCreate;
    x.isEdit = this.isEdit;
    x.isView = this.isView;

    if(!x.visitId){
      x.visitId = null;
      x.createdBy = null;
    }
    if(!x.regId){
      x.regId = "00000000-0000-0000-0000-000000000000";
    }
    if(!x.regMst){
      x.regMst = null
    }
    this.currentView=x;

    this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/download`, x).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

      if ((x.fileName as string).indexOf(".jpg") > -1 || (x.fileName as string).indexOf(".jpeg") > -1 || (x.fileName as string).indexOf(".png") > -1 || (x.fileName as string).indexOf(".PNG") > -1 || (x.fileName as string).indexOf(".dcm") > -1 || (x.fileName as string).indexOf(".IMA") > -1 || (x.fileName as string).indexOf(".ima") > -1|| (x.fileName as string).indexOf(".DCM") > -1) {
        this.isImgView = true;
        this.srcname = 'data:image/jpeg;base64,' + data;
       
        x.file = data;
        if (this.currentView) {
          this.currentView.file = data;
        }
       
      }
      else {
        this.isImgView = false;
        this.currentView={};
        this.downloadFileRes(data, x.fileName);
      }

    }, (error) => {

    }, () => {

    });
  }


  getStorageDet(): void {
    this.phySrvc.list(`AtchDet/${this.tenantId}/${this.branchId}/getStorageSizeForTenant`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      var purchasedGB = data.purchasedGB;
      var usedStorageGB = data.usedGB;
      this.storageExceeds = false;
      // if(purchasedGB - usedStorageGB <= 0){
      //   this.storageExceeds = true;
      // }
    }, (error) => {

    }, () => {
    });
  }

  handleFileInput(files: any) {
    if (!this.storageExceeds) {
      this.filesizeflag = false;
      this.storageExceedsErrMsg = false;
      let sizeInBytes: number = files.currentTarget.files[0].size;
      this.bytesToSize(sizeInBytes);
      if (files.currentTarget.files.length > 0) {
        this.fileToUpload = files.currentTarget.files[0];
      }
    }
    else {
      this.storageExceedsErrMsg = true;
    }
  }
  
  bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    let i = Number(Math.floor(Math.log(bytes) / Math.log(1024)));
    this.filesize = Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
    var fs = Math.round(bytes / Math.pow(1024, i));
    var kb = Math.round(Number(bytes / 1024) - Number(Math.round(bytes / Math.pow(1024, i)) * 1024))
    if (fs > 50 && i > 1) {
      this.filesizeflag = true;

    }
    return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
  }

  onSave(): void {
    this.isSubmitted = true;
    this.isBtnSubmitted = true;
    if (this.atchForm.invalid) {
      this.isBtnSubmitted = false;
      return;
    }
    const formData: FormData = new FormData();
    formData.append('fileKey', this.fileToUpload, this.fileToUpload.name);
    let fileLoc=""
    if(this.category=="Billing"){
      let fileName=this.name+"_Billing_"+this.referenceNo;
      fileLoc = `${this.tenantId}/${this.branchId}/${this.regId}/${this.category}/${fileName}`
    }
    else{
      fileLoc = `${this.tenantId}/${this.branchId}/${this.category}/${this.referenceNo}/${this.fileToUpload.name}`
    }
    let postData: any = {
      regId: this.regId,
      tenantId: this.tenantId,
      branchId: this.branchId,
      containerName: this.tenantId,
      fileLocation: fileLoc,
      fileName: this.fileToUpload.name,
      category: this.category,
      doneDate: this.dateServices.currentDate(),
      doneBy: this.doneBy,
      fileAddedBy: this.addedBy,
      subcategory: this.subCategory,
      notes: this.atchForm.get("notes").value,
      referenceNo: this.referenceNo,
      tagType: "none",
      fileAddedFrom: this.category,
      isEdit: this.isEdit,
      isCreate: this.isCreate,
      createdBy: this.doneBy,
      tagName:this.atchForm.get("tagName").value,
      visitId:this.woundCare?this.referenceNo:this.visitId
    }

    for (const prop in postData) {
      if (!postData.hasOwnProperty(prop)) { continue; }
      formData.append(prop, postData[prop]);
    }

    this.radiologySrvc.createWithProgress(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/attachDoc`, formData).pipe(
      map((event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            const progress = Math.round((100 * event.loaded) / (event.total || 1));
            return { progress }; // Only return progress until the response is available

          case HttpEventType.Response:
            return { progress: 100, response: event.body }; // Return the final response with 100% progress

          default:
            return { progress: 0 };
        }
      })).pipe(takeUntil(this.unsubscribe$)).subscribe(({ progress, response }) => {
        this.uploadProgress = progress;
        if (response) {
          this.uploadProgress = 0;
          this.searchDet();
        }
      }, (error) => {
        this.isBtnSubmitted = false;
      }, () => {
        this.changeDocType('all')
        this.isconfirmation = true;
        setTimeout(() => {
          this.isconfirmation = false;
        }, 4000);

        this.onClear();
        this.attachmentSaved.emit();
      });
  }

  get fval() { return this.atchForm.controls; }


  onClear(): void {
    this.isBtnSubmitted = false;
    this.isSubmitted = false;
    this.filesizeflag = false;
    this.storageExceedsErrMsg = false;
    this.atchForm.reset();
    // this.backToMain();
  }

  fetchUsertype() {
    this.userService.userList(`users/userlist/${this.tenantId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.userdata = data;
      this.doneBy = parseInt(localStorage.getItem("userId"));
    }, (error) => {
    }, () => {
    });
  }

  downloadFileRes(data: any, filename: string) {

    var binary_string = window.atob(data);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    var byteArray = bytes.buffer;

    if (filename.indexOf(".pdf") > -1) {
      var blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    }
    else {
      var blob = new Blob([byteArray]);
      FileSaver.saveAs(blob, filename, true);
    }

  }
  get getApiUrl(): string {
    return environment.apiUrl;
  }

  goBack(){
    this.valueUpdateEvent.emit();
  }

  getFileType(fileName: string): string {
  const parts = fileName.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "unknown";
}
  getFileIcon(fileName){
    const ext = fileName.split('.').pop()?.toLocaleLowerCase();
    if (!fileName) {
      return 'assets/images/empty/app/pdf.svg';
    }
    const iconMap: { [key: string]: string } = {
      'pdf': 'assets/images/empty/app/pdf.svg',
      'doc': 'assets/images/empty/app/word_16x1.svg',
      'docx': 'assets/images/empty/app/word_16x1.svg',
      'odt': 'assets/images/empty/app/word_16x1.svg',
      'xls': 'assets/images/empty/app/excel_16x1.svg',
      'xlsx': 'assets/images/empty/app/excel_16x1.svg',
      'jpg': 'assets/images/empty/app/pngImage.png',
      'jpeg': 'assets/images/empty/app/pngImage.png',
      'png': 'assets/images/empty/app/pngImage.png',
      'txt': 'assets/images/empty/app/word_16x1.svg',
      'ppt': 'assets/images/empty/app/powerpoint_16x1.svg',
      'pptx': 'assets/images/empty/app/powerpoint_16x1.svg'
    };

    return iconMap[ext] || '../.././../../assets/images/empty/app/pdf.svg';
  }

  imageClick(c,g){
    this.imagelistload = true;
    const variety = c
    const group = g;
    this.folderView=true;
    // this.view(g[c][0])
    this.keyValue=c;
    this.valuePair = g[c];
    this.groupedAttachments;
   // this.sendStaticPayload(this.valuePair)
  }
  backToMain(){
    this.folderView=false;
    this.valuePair=[];
 
    this.crosshairModeEnabled = false;
  
  }
  groupBy(data,val){
     if(this.groupByType=='detail'){
      this.groupedAttachments=[];
      return}
     const allowedExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg",
      ".dcm",".ima"];
// Step 1: Filter only image files
      var exattachmentListGrid = data.filter(x =>
          allowedExtensions.some(ext => (x.fileName as string).toLowerCase().includes(ext))
        );
        if(this.groupByType == 'tag'){
          exattachmentListGrid = exattachmentListGrid.filter(x => !!x?.tagName && x?.tagName !=='null')
        }
       
       const groupedByDate = Object.entries(
      data?.reduce((acc: { [key: string]: any[] }, item) => {
        const rawDate = item?.doneDate;
        const dateOnly = rawDate ? new Date(rawDate).toISOString().split('T')[0] : 'Uncategorized';
        const category = dateOnly;
        if (!acc[category]) acc[category] = [];
        acc[category].push(item);
        return acc;
      }, {})
    ).map(([key, value]) => ({ [key]: value }));
 
      const groupedByTag = Object.entries(
      exattachmentListGrid?.reduce((acc: { [key: string]: any[] }, item) => {
        const category = item?.tagName ?? 'Uncategorized';
        if (!acc[category]) acc[category] = [];
        acc[category].push(item);
        return acc;
      }, {})
    ).map(([key, value]) => ({ [key]: value }));
    this.groupedAttachments = val === 'tag' ? (exattachmentListGrid?.length > 0 ?groupedByTag:[]) : groupedByDate;

  }
  filterGrid(data) {
  if (data?.length > 0) {
     if(this.groupByType!='detail'){
    const excludedExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg" ,".dcm",".ima"];
    if(this.groupByType =='tag'){
    this.attachmentListGrid = data.filter(x => {
        const fileName = (x.fileName as string)?.toLowerCase();
        const isImage = excludedExtensions.some(ext => fileName?.includes(ext));
        const hasTag = !!x?.tagName && x?.tagName !=='null';

        // Include if not an image OR it's an image without a tag
        return !isImage || (isImage && !hasTag);})
    }else if(this.groupByType =='date'){
      this.attachmentListGrid = data.filter(x =>
      !excludedExtensions.some(ext => (x.fileName as string).toLowerCase().includes(ext)))
    }
    }else{this.attachmentListGrid=data;}
  } else {
    this.attachmentListGrid = [];
  }
}


groupByTypeFtn(val){
  this.groupByType=val;
 // this.changeDocType('img');
  this.filterGrid(this.totalAttachment);
  this.groupBy(this.totalAttachment,this.groupByType);
}


//Dicom Integration
toolEnable(c: { fileName: string }): boolean {
  const allowedExtensions = [
    ".jpg", ".jpeg", ".png",".dcm", ".ima"
  ];

  const fileName = c.fileName.toLowerCase();
  return allowedExtensions.some(ext => fileName.endsWith(ext));
}


  initializeCornerstone() {
    if(this.intialFlag)return
    cornerstoneWebImageLoader.configure({
      useWebWorkers: true,
      decodeConfig: {
        convertFloatPixelDataToInt: false,
        use16BitDataType: false,
        readDicomPrefix: false
      }
    });
    
    cornerstoneWebImageLoader.external.cornerstone = cornerstone;
    cornerstoneWebImageLoader.external.dicomParser = dicomParser;

    // cornerstoneWADOImageLoader.webWorkerManager.initialize({
    //   webWorkerPath: '/assets/cornerstone/webworkers/cornerstoneWADOImageLoaderWebWorker.js',
    //   taskConfiguration: {
    //     'decodeTask': {
    //       codecsPath: '/assets/cornerstone/codecs/cornerstoneWADOImageLoaderCodecs.js'
    //     }
    //   }
    // });
    this.intialFlag=true;
  }
  
//Python code starts
private isImageFile(fileName: string): boolean {
  const name = (fileName || '').toString().toLowerCase();
  return [
    '.jpg',
    '.jpeg',
    '.png',
    '.gif',
    '.bmp',
    '.webp',
    '.svg',
    '.dcm',
    '.ima'
  ].some(ext => name.endsWith(ext));
}

private hasBase64Data(file: any): boolean {
  return typeof file === 'string' && file.trim().length > 0;
}

Newview(x: any)
{
  if (!x) {
    return;
  }

  this.fetchPageAccess();
  this.currentView = x;
  this.imagelistload = false;

  if (this.isImageFile(x?.fileName)) {
    if (this.hasBase64Data(x?.file)) {
      this.isImgView = true;
      this.srcname = 'data:image/jpeg;base64,' + x.file;
      return;
    }

    this.view(x);
    return;
  }

  this.view(x);
  
}

viewImg(x,y?){
  let val;
  if(!!y){
 val = x[y][0];}else{
  val=x;
 }

  this.handleThumbnailSelection(x);
  this.toolView=true; 
}

sendStaticPayload(get:any) {
if(get?.length ==0) return;
  const staticPayload = {
  "images":get?.map(f => ({
    base64: f.file,
    fileName: f.fileName,
    id:f.id
  }))
};
  this.dicomUploadService.uploadBase64Images(staticPayload.images).subscribe({
    next: (response: any) => {
      this.handleBackendResponse(response);
    },
    error: (err) => {
      this.handleBackendError(err);
    }
  });
}
handleBackendResponse(response: any) {
  this.responses = response.images;
  
  // Store the original base64 data for metadata fetching
  this.responses.forEach((response, index) => {
    if (response.base64) {
      // Store the base64 data for later use
      this.responses[index].base64 = response.base64;
    }
  });
  
  // Generate thumbnail images for display
  this.thumbnailImages = this.responses
    .filter(img => img.imageUrl) // Only include images with valid URLs
    .map(img => ({
      imageId: img.imageUrl,
      seriesDescription: img.fileName,
      metadata: img.metadata,
      fileType: img.fileType,
      id:img?.id
    }));
    this.attachmentList;
}
  // Handle backend errors
  handleBackendError(error: any) {
    if (error.status === 0) {
      this.uploadError = 'Cannot connect to Python backend. Make sure it\'s running on port 5001.';
    } else {
      this.uploadError = error.message || 'Unknown error occurred';
    }
    // console.error('Backend error:', error);
  }

callUpdate(x){
  this.addAttachment=true;
  this.updatePair = x;
  this.updateFlag=true;
  this.atchForm.get('notes').setValue(!!x?.notes &&x?.notes!='null'?x?.notes:'');
  this.atchForm.get('tagName').setValue(!!x?.tagName &&x?.tagName!='null'?x?.tagName:'');
  this.addedBy= x?.fileAddedBy;
  // this.sourceDisable=true;
  if(this.ehrFlag)
    this.isCategoryFieldReadOnly=true;
}

onUpdateEdit(){
  const Update ={
    "id": this.updatePair?.id,
    "regId": this.regId,
    "notes": this.atchForm.get('notes')?.value,
    "tagName": this.atchForm.get('tagName')?.value,
    "tenantId": this.tenantId,
    "branchId": this.branchId,
    "addedBy":this.addedBy
}
this.rolesService.update(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/updateAtch`, Update).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
  if(data?.code ==200){
      this.attachmentList = this.attachmentList.map(x => {
          if (x.id === this.updatePair?.id) {
            return {
              ...x,
              notes: this.atchForm.get('notes')?.value,
              tagName: this.atchForm.get('tagName')?.value,
              fileAddedBy:this.addedBy
            };
          }
          return x;
      });
      this.totalAttachment = this.totalAttachment.map(x => {
        if (x.id === this.updatePair?.id) {
          return {
            ...x,
            notes: this.atchForm.get('notes')?.value,
            tagName: this.atchForm.get('tagName')?.value,
            fileAddedBy:this.addedBy
          };
        }
        return x;
      });
      this.backToMain();
      this.filterGrid(this.attachmentList);
      this.groupBy(this.totalAttachment,this.groupByType);
      this.updatePair = {};
      this.updateFlag=false;
      this.cancelAddAttachment();
      //this.sourceDisable=false;
      this.toaster.ForSuccess("Updated SucessFully");
      if(this.ehrFlag)
        this.isCategoryFieldReadOnly=false;

  }


},(err)=>{
  this.toaster.ForDanger("Record Not Updated");
},()=>{

})
}
printpop:boolean=false;
imgDataPrint:string;
print(val){
  if(!!val){
    this.patient;
    if(this.psDetails==null)this.loadPrinterSettingsAndLogo();
  this.printpop=true;
  this.imgDataPrint=val;}
}

loadPrinterSettingsAndLogo() {
        this.iatchSrvc.getById(environment.apiUrl+"/ImageAtchDet/"+this.tenantId +"/"+this.branchId+ "/downloadTenantImage/logo/List").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.Printsrcname = 'data:image/jpeg;base64,' + data.blob;
          var ps=data.printerSettings;
        if(ps!=null){​​​
          this.psDetails=ps;
          this.styleUrl="/assets/css/print.css,/assets/css/"+(this.psDetails.paperSize).toLowerCase()+(this.psDetails.orientation).toLowerCase()+".css";
          this.psDetails.topHeaderLogoPosition="center "+this.psDetails.topHeaderLogoPosition;
          this.psDetails.topHeaderPosition="center "+this.psDetails.topHeaderPosition;
          this.psDetails.reportHeaderPlacement="center "+this.psDetails.reportHeaderPlacement;
          this.psDetails.topHeaderLogoRequired=this.psDetails.topHeaderLogoRequired =="1" ? true : false;
          this.psDetails.topHeaderRequired=this.psDetails.topHeaderRequired =="1" ? true : false;
          this.psDetails.bottomFooterLogoPosition="center "+this.psDetails.bottomFooterLogoPosition;
          this.psDetails.bottomFooterPosition="center "+this.psDetails.bottomFooterPosition;
          this.psDetails.bottomFooterLogoRequired=this.psDetails.bottomFooterLogoRequired =="1" ? true : false;
          this.psDetails.bottomFooterRequired=this.psDetails.bottomFooterRequired =="1" ? true : false;
    
         }
         else{
          this.styleUrl="/assets/css/print.css,/assets/css/a4landscape.css";
         }   
          }, (error) => {
          }, () => {
           
          });
    
}

openSelectedImages() {
  if (this.selectedImages?.length === 0) return;

  this.toolView = true;
  this.selectedImage = this.selectedImages[0];

  setTimeout(() => {
    if (this.viewPort) {
      this.viewPort.resetViewer();
      this.viewPort.resetImageCache();
      
      // Pass the crosshair mode setting
      this.viewPort.crosshairModeEnabled = this.crosshairModeEnabled;
      
      // Pass images with their base64 data and filenames
      const orderedImages = this.selectedImages.map((image, index) => {
        // Find the original response to get base64 data
        const originalResponse = this.responses.find(r => r.imageUrl === image.imageId);
        
        return {
          ...image,
          base64: originalResponse?.base64 || '', // Pass the base64 data
          fileName: originalResponse?.fileName || image?.seriesDescription, // Pass the filename
          selectionOrder: index // Maintain selection order
        };
      });
      
      this.viewPort.loadStudyImages(orderedImages);
      
      // Enable stack scroll if multiple images
      if (this.selectedImages.length > 1) {
        this.viewPort.stackScrollManuallyEnabled = false;
        this.viewPort.enableStackScrollWheel();
      }
    }
  }, 0);
}

handleThumbnailSelection(val: any) {
  var image = this.thumbnailImages?.find(x =>
    (val?.id && x?.id == val?.id) ||
    (val?.imageId && x?.imageId === val?.imageId) ||
    (val?.fileName && (x?.seriesDescription === val?.fileName || x?.fileName === val?.fileName)) ||
    (val?.seriesDescription && (x?.seriesDescription === val?.seriesDescription || x?.fileName === val?.seriesDescription))
  );

  const targetImage = image || val;
  if (this.crosshairModeEnabled) {
    // Toggle selection in crosshair mode
    const index = this.selectedImages?.findIndex(img => img?.imageId === targetImage?.imageId);
    if (index >= 0) {
      val.compareCheck=false;
      this.selectedImages?.splice(index, 1); // Deselect

    } else {
      // Find the original response to get base64 data
      const originalResponse = this.responses?.find(r => r?.imageUrl === targetImage?.imageId || (targetImage?.id && r?.id == targetImage?.id));

      // Add base64 data to the selected image
      const imageWithData = {
        ...targetImage,
        base64: originalResponse?.file || originalResponse?.base64 || '' ,
        fileName: originalResponse?.fileName || targetImage?.seriesDescription || targetImage?.fileName
      };
      val.compareCheck=true;
      if(!!imageWithData?.fileName)
      this.selectedImages?.push(imageWithData); // Select
    }
  } else {
    // Normal mode - open image directly with base64 data
    this.openImageViewer(targetImage);
  }

}

openImageViewer(val: any) {
  if (!val) return;

  let image = this.thumbnailImages?.find(x =>
    (val?.id && x?.id == val?.id) ||
    (val?.imageId && x?.imageId === val?.imageId) ||
    (val?.fileName && (x?.seriesDescription === val?.fileName || x?.fileName === val?.fileName)) ||
    (val?.seriesDescription && (x?.seriesDescription === val?.seriesDescription || x?.fileName === val?.seriesDescription))
  );

  // If this image has not yet been processed by backend (e.g. still in flight or not uploaded yet), process on-demand immediately
  if ((!image || !image.imageId) && !val?.imageId && !val?.imageUrl) {
    const base64Data = val?.file || val?.base64 || (this.srcname && this.srcname.includes('base64,') ? this.srcname.split('base64,')[1] : '');
    if (base64Data) {
      const payload = [{
        base64: base64Data,
        fileName: val?.fileName || val?.seriesDescription || 'image.ima',
        id: val?.id
      }];
      this.dicomUploadService.uploadBase64Images(payload).subscribe({
        next: (response: any) => {
          if (response?.images?.length > 0) {
            const processed = response.images[0];
            const newThumb = {
              imageId: processed.imageUrl,
              imageUrl: processed.imageUrl,
              seriesDescription: processed.fileName,
              metadata: processed.metadata,
              fileType: processed.fileType,
              id: processed.id || val?.id
            };
            if (!this.thumbnailImages) this.thumbnailImages = [];
            const existingIdx = this.thumbnailImages.findIndex(t => t?.imageId === newThumb.imageId || (newThumb.id && t?.id == newThumb.id));
            if (existingIdx >= 0) {
              this.thumbnailImages[existingIdx] = newThumb;
            } else {
              this.thumbnailImages.push(newThumb);
            }
            if (!this.responses) this.responses = [];
            this.responses.push({ ...processed, base64: base64Data });
            this.openImageViewer(newThumb);
          }
        },
        error: (err) => {
        }
      });
      return;
    }
  }

  image = image || val;
  const originalResponse = this.responses?.find(r =>
    r?.imageUrl === image?.imageId ||
    (image?.id && r?.id == image?.id) ||
    (image?.fileName && r?.fileName === image?.fileName) ||
    (image?.seriesDescription && r?.fileName === image?.seriesDescription)
  );
  const base64Data = originalResponse?.base64 || originalResponse?.file || val?.file || val?.base64 || '';
  const imageId = image?.imageId || image?.imageUrl || val?.imageId || val?.imageUrl || '';
  const seriesDesc = image?.seriesDescription || val?.fileName || val?.seriesDescription || originalResponse?.fileName || 'Image';
  const fileName = originalResponse?.fileName || image?.seriesDescription || val?.fileName || val?.seriesDescription || 'image.ima';

  const singleImageArray = [{
    imageId: imageId,
    imageUrl: imageId,
    seriesDescription: seriesDesc,
    base64: base64Data,
    fileName: fileName
  }];

  // Set imagesToDisplay so [images] receives it immediately when *ngIf="toolView" renders
  this.imagesToDisplay = singleImageArray;
  this.selectedImage = image;
  this.crosshairModeEnabled = false;
  this.toolView = true;

  // Also call viewPort.loadStudyImages directly if viewPort is already mounted
  setTimeout(() => {
    if (this.viewPort) {
      this.viewPort.resetViewer();
      this.viewPort.resetImageCache();
      this.viewPort.crosshairModeEnabled = false;
      this.viewPort.loadStudyImages(singleImageArray);
    }
  }, 50);
}


getImageSrc(x: any): string {
  const allowedExtensions = [".jpg", ".jpeg", ".png"];
  //".gif", ".bmp", ".webp", ".svg", ".dcm", ".ima"
  const ext = x?.fileName?.split('.').pop()?.toLowerCase();
  if (!ext) return 'assets/images/woundcare/zip.png'; // fallback

  if (allowedExtensions.includes(`.${ext}`)) {
    return `data:image/jpeg;base64,${x?.file}`;
  }

  switch (ext) {
    case 'doc':
    case 'docx':
    case 'pdf':
      return 'assets/images/woundcare/word.png';
    case 'xls':
    case 'csv':
    case 'xlsx':
      return 'assets/images/woundcare/xls.png';
    case 'zip':
    case 'rar':
      return 'assets/images/woundcare/zip.png';
    case 'ima':
    case 'dcm':
    case 'txt':
      return 'assets/images/woundcare/mute.png';
    default:
      return 'assets/images/woundcare/img.png'; // generic fallback
  }
}
 utcToLocalConversion(date) {
    if (date != null && date != "" && date != undefined) {
      return this.dateServices?.dateUtctoLocalDateAndTime(date);
    }
  }

  getPatientFullName(): string {
    const name = [this.patient?.firstname, this.patient?.middlename, this.patient?.lastname]
      .filter(x => !!x && x.toString().trim() != '').join(' ');
    return name || this.patient?.patientName || '';
  }

   getPatientAgeByDOB(dob, ageResult, dobFlag): any {

    if (dobFlag == "Y") {

      var patientDob = new Date(dob);

      var Difference_In_Time = Math.abs(Date.now() - patientDob.getTime());
      var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
      var ageValue = Difference_In_Days / 365.25;
      ageValue = Math.trunc(ageValue);
      //extract the year, month, and date from user date input
      var dobMonth = patientDob.getMonth();
      var dobDate = patientDob.getDate();

      //get the current date from the system
      var now = new Date();
      //extract the year, month, and date from current date
      var currentMonth = now.getMonth();
      var currentDate = now.getDate();

      //get months
      if (currentMonth >= dobMonth)
        //get months when current month is greater
        var monthAge = currentMonth - dobMonth;
      else {
        var monthAge = 12 + currentMonth - dobMonth;
      }

      //get days
      if (currentDate >= dobDate)
        //get days when the current date is greater
        var dateAge = currentDate - dobDate;
      else {
        monthAge--;
        var dateAge = 31 + currentDate - dobDate;

        if (monthAge < 0) {
          monthAge = 11;
        }
      }
      return ageValue + ' Y ' + monthAge + ' M ' + dateAge + ' D'

    } else {


      if (ageResult != null) {

        var patientAgeResult = new Date(ageResult);

        var Difference_In_Time = Math.abs(Date.now() - patientAgeResult.getTime());
        var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
        var ageValue = Difference_In_Days / 365.25;
        ageValue = Math.trunc(ageValue); //Get Before Decimal Value

        //extract the year, month, and date from user date input
        var dobYear = patientAgeResult.getFullYear();
        var dobMonth = patientAgeResult.getMonth();
        var dobDate = patientAgeResult.getDate();

        //get the current date from the system
        var now = new Date();
        //extract the year, month, and date from current date
        var currentMonth = now.getMonth();
        var currentDate = now.getDate();

        //get months
        if (currentMonth >= dobMonth)
          //get months when current month is greater
          var monthAge = currentMonth - dobMonth;
        else {
          var monthAge = 12 + currentMonth - dobMonth;
        }

        //get days
        if (currentDate >= dobDate)
          //get days when the current date is greater
          var dateAge = currentDate - dobDate;
        else {
          monthAge--;
          var dateAge = 31 + currentDate - dobDate;

          if (monthAge < 0) {
            monthAge = 11;
          }
        }
        return ageValue + ' Y ' + monthAge + ' M ' + dateAge + ' D'
      } else {
        return '-'

      }
    }
  }

toggleSort() {
  this.sortOrder = this.sortOrder === 'Asc' ? 'Dsc' : 'Asc';

  if (this.sortOrder === 'Asc') {
    this.attachmentList = this.attachmentList.sort(
      (a, b) => new Date(a?.doneDate || 0).getTime() - new Date(b?.doneDate || 0).getTime()
    );
  } else {
    this.attachmentList = this.attachmentList.sort(
      (a, b) => new Date(b?.doneDate || 0).getTime() - new Date(a?.doneDate || 0).getTime()
    );
  }

  this.filterGrid(this.attachmentList);
  this.groupBy(this.attachmentList, this.groupByType);
}
checkAll(x,event: any) {
  const checked = event.target.checked;
  if (checked) {
    this.selectedImages = [];
    this.selectedImages = this.thumbnailImages.map(img => {
      const originalResponse = this.responses?.find(r => r?.imageUrl === img?.imageId);
      return {
        ...img,
        base64: originalResponse?.file || '',
        fileName: originalResponse?.fileName || img?.seriesDescription
      };
    });
    if(x?.length > 0)x?.forEach(t => t.compareCheck = true);

  } else {
    this.resetCheckAll();
   
  }
}

resetCheckAll(){
   this.selectedImages = [];
    if(this.attachmentListGrid?.length > 0)this.attachmentListGrid?.forEach(x => x.compareCheck = false);
    if(this.valuePair?.length > 0)this.valuePair.forEach(x => x.compareCheck = false);

}

}
